import { PageSection } from 'pricing-pages-ui-components/semantic/PageSection';
import { FREE } from 'self-service-api/constants/ProductLevels';
import { getMerchCardsToShow, getMerchCardsToShowSSM0009 } from '../../constants/merchCards/MerchCardsToShow';
import { NavItemEnum } from '../../constants/routing/NavItems';
import { useSSM0009Experiment } from '../../utils/experiments/ssm0009';
import { MerchCardShadowColumns } from './MerchCardSharedComponents';
import SuiteFreeTile from './SuiteFreeTile';
import { SuiteTile } from './SuiteTile';
import { jsx as _jsx } from "react/jsx-runtime";
// This is used as the merch cards for the customer platform routes
export const SuiteTiles = ({
  selectedTab,
  isFreeToStarter,
  screen
}) => {
  const {
    isSSM0009Variant
  } = useSSM0009Experiment();
  const productLevelsToShow = isSSM0009Variant ? getMerchCardsToShowSSM0009({
    // TODO - should pass in navItem as prop or track navItem in redux
    navItem: isFreeToStarter ? NavItemEnum.FREE : NavItemEnum.SUITE
  }) : getMerchCardsToShow({
    tab: selectedTab,
    isFreeToStarter
  });
  const suiteCardComponents = productLevelsToShow.map((productLevel, index) => {
    const gridItemProps = {
      gridColumnStart: index + 1,
      paddingInline: '700'
    };
    if (FREE === productLevel) {
      return /*#__PURE__*/_jsx(SuiteFreeTile, {
        isFreeToStarter: isFreeToStarter,
        gridItemProps: gridItemProps
      }, productLevel);
    }
    return /*#__PURE__*/_jsx(SuiteTile, {
      productLevel: productLevel,
      gridItemProps: gridItemProps,
      screen: screen
    }, productLevel);
  });
  const columns = productLevelsToShow.length;
  return /*#__PURE__*/_jsx(PageSection, {
    hideOverflow: false,
    children: /*#__PURE__*/_jsx(MerchCardShadowColumns, {
      columns: columns,
      children: suiteCardComponents
    })
  });
};